// extracted by mini-css-extract-plugin
export default {"link":"style-module--link--44cb7","content":"style-module--content--b383a"};